import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchConclusionService = () => {
  return new ServicesUseCase(
    '/avaliacaoPsicologica/conclusionAvaliacao',
    makeAxiosHttpClient()
  )
}
